var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Modal",
    {
      attrs: {
        id: "credit-card-needed",
        "show-footer": false,
        "show-title": false,
        design: "v3",
      },
      on: { cancel: _vm.cancel },
    },
    [
      _c(
        "div",
        { staticClass: "content" },
        [
          _c(
            "div",
            { staticClass: "icon-wrapper" },
            [_c("CreditCardNeeded")],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "title" }, [
            _vm._v(_vm._s(_vm.$t("message.creditCardRequiredModalTitle"))),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "description" }, [
            _vm._v(_vm._s(_vm.$t("message.creditCardRequiredModalDesc"))),
          ]),
          _vm._v(" "),
          _c(
            "SupsisButton",
            { attrs: { primary: "" }, on: { click: _vm.forward } },
            [_vm._v(_vm._s(_vm.$t("message.continue")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }